// extracted by mini-css-extract-plugin
export default {"iban":"IBAN_iban__714sT","input":"IBAN_input__MWY18","success":"IBAN_success__eJFqx","error":"IBAN_error__QZP5G","natural":"IBAN_natural__vlwmC","label":"IBAN_label__9CKTQ"};